import { render, staticRenderFns } from "./AzureTtsLive2dPanel.vue?vue&type=template&id=461be0de&scoped=true&"
import script from "./AzureTtsLive2dPanel.vue?vue&type=script&lang=js&"
export * from "./AzureTtsLive2dPanel.vue?vue&type=script&lang=js&"
import style0 from "./AzureTtsLive2dPanel.vue?vue&type=style&index=0&id=461be0de&prod&scoped=true&lang=less&"
import style1 from "./AzureTtsLive2dPanel.vue?vue&type=style&index=1&id=461be0de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461be0de",
  null
  
)

export default component.exports